var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-breadcrumbs',{attrs:{"breadCrumbs":_vm.breadCrumbs}}),_vm._l((_vm.items),function(item){return _c('select-route',{key:item.id,attrs:{"item":item},on:{"onClick":_vm.onClick}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }